// extracted by mini-css-extract-plugin
export default {"box":"home_box__bNEBk"};